import React, { useState } from "react";
import { useRacketLabAdminT } from "@/i18n/racketLabAdminI18n";

/**
 * LegacyClassifyForm — Sub-sprint D-β-β.
 *
 * Form for `POST /admin/racket-lab/_ops/legacy-memberships-classify`.
 * Bucket radio (BACKFILL / SOFT_REVOKE / EXCLUDE). BACKFILL reveals
 * role / shop_ids (org pre-locked to pilot).
 */
const ALLOWED_ROLES = ["admin", "staff", "shop_manager", "operator", "racket_technician", "head_coach"];

export const LegacyClassifyForm = ({ value, onChange, disabled = false, pilotOrgId = "TEAMSOFTWAREINNOVATIONS" }) => {
  const t = useRacketLabAdminT();
  const [local, setLocal] = useState(
    value || { user_id: "", bucket: "SOFT_REVOKE", reason: "", role: "shop_manager", organisation_id: pilotOrgId, shop_ids: [] },
  );
  const update = (k, v) => { const next = { ...local, [k]: v }; setLocal(next); onChange?.(next); };
  const isBackfill = local.bucket === "BACKFILL";
  const shopsText = (local.shop_ids || []).join("\n");

  return (
    <div data-testid="rl-ops-legacy-classify-form" className="flex flex-col gap-3">
      <label className="flex flex-col gap-1 text-xs">
        <span className="font-medium text-slate-700">{t("ops.legacy.classify.user_id_label")}</span>
        <input data-testid="rl-ops-legacy-classify-user-id" value={local.user_id} onChange={(e) => update("user_id", e.target.value)} disabled={disabled} placeholder={t("ops.legacy.classify.user_id_placeholder")} className="rounded-md border border-slate-300 px-2 py-1 text-sm font-mono" />
      </label>

      <div className="flex flex-col gap-1 text-xs">
        <span className="font-medium text-slate-700">{t("ops.legacy.classify.bucket_label")}</span>
        <div className="flex flex-wrap gap-2">
          {["BACKFILL", "SOFT_REVOKE", "EXCLUDE"].map((b) => (
            <label key={b} className="inline-flex items-center gap-1">
              <input
                type="radio"
                name="bucket"
                value={b}
                checked={local.bucket === b}
                onChange={() => update("bucket", b)}
                disabled={disabled}
                data-testid={`rl-ops-legacy-classify-bucket-${b.toLowerCase().replace(/_/g, "-")}`}
              />
              <span className="font-mono">{b}</span>
            </label>
          ))}
        </div>
      </div>

      <label className="flex flex-col gap-1 text-xs">
        <span className="font-medium text-slate-700">{t("ops.legacy.classify.reason_label")}</span>
        <input data-testid="rl-ops-legacy-classify-reason" value={local.reason || ""} onChange={(e) => update("reason", e.target.value)} disabled={disabled} className="rounded-md border border-slate-300 px-2 py-1 text-sm" />
      </label>

      {isBackfill && (
        <>
          <label className="flex flex-col gap-1 text-xs">
            <span className="font-medium text-slate-700">{t("ops.legacy.classify.role_label_backfill")}</span>
            <select data-testid="rl-ops-legacy-classify-role" value={local.role} onChange={(e) => update("role", e.target.value)} disabled={disabled} className="rounded-md border border-slate-300 px-2 py-1 text-sm">
              {ALLOWED_ROLES.map((r) => (<option key={r} value={r}>{r}</option>))}
            </select>
          </label>
          <label className="flex flex-col gap-1 text-xs">
            <span className="font-medium text-slate-700">{t("ops.legacy.classify.org_label_locked")}</span>
            <input data-testid="rl-ops-legacy-classify-org" value={local.organisation_id} disabled className="rounded-md border border-slate-200 bg-slate-100 px-2 py-1 text-sm text-slate-500" />
          </label>
          <label className="flex flex-col gap-1 text-xs">
            <span className="font-medium text-slate-700">{t("ops.legacy.classify.shop_ids_label")}</span>
            <textarea data-testid="rl-ops-legacy-classify-shops" value={shopsText} onChange={(e) => update("shop_ids", e.target.value.split("\n").map((s) => s.trim()).filter(Boolean))} disabled={disabled} rows={3} className="rounded-md border border-slate-300 px-2 py-1 text-sm font-mono" />
          </label>
        </>
      )}

      <p className="text-[10px] text-slate-500">
        {t("ops.legacy.classify.footer_note")}
      </p>
    </div>
  );
};

export default LegacyClassifyForm;
